import {animateFraworkSvgs} from "./consultancyFrameworkAnims";
import { animateConultancyHeaderStart } from "./consultancyHeaderAnims";

animateConultancyHeaderStart();
animateFraworkSvgs();
